import { getYandexMetrikaCounter, getYandexMetrikaCounterId, reachYandexGoal } from 'utils/analytics/yandexMetrika'
import { onboardingLog } from './store/logger'

/**
 * Send reachGoal events configured on a learning config button.
 * @param {object} button — Button from learningConfigs
 * @param {{ trackId?: string, cardId?: string, pageId?: string }} [context]
 */
export const trackOnboardingButtonAnalytics = (button, context = {}) => {
  const goal =
    button?.analyticsGoal ??
    (button?.action === 'confirm-interrupt' ? 'onboarding_close_click' : null)

  if (!goal) {
    onboardingLog('analytics:skip', {
      reason: 'no analyticsGoal',
      action: button?.action,
      label: button?.label,
      ...context,
    })
    return
  }

  sendOnboardingEvent(goal, {
    trackId: context.trackId,
    cardId: context.cardId,
    pageId: context.pageId,
    ...button.analyticsParams,
  })
}

/**
 * Send onboarding event to Yandex.Metrika and dataLayer.
 * @param {string} eventName - event goal name
 * @param {object} [params] - optional params for the event
 */
export const sendOnboardingEvent = (eventName, params) => {
  const counterId = getYandexMetrikaCounterId()
  const hasYm = Boolean(counterId && typeof window?.ym === 'function')
  const hasDataLayer = Boolean(global.dataLayer)

  reachYandexGoal(eventName, params)

  if (hasDataLayer) {
    global.dataLayer.push({ event: eventName, ...params })
  }

  onboardingLog('analytics:send', {
    goal: eventName,
    params,
    counterId,
    channels: {
      yaCounter: Boolean(getYandexMetrikaCounter()),
      ym: hasYm,
      dataLayer: hasDataLayer,
    },
  })
}
